import React, { useState } from "react";
import { createRoot } from "react-dom/client";
import TopContent from "./topcontent";

document.addEventListener("DOMContentLoaded", () => {
  document.title = "Leonard Bay";

  const contentDivElem = document.getElementById("contentDivId");
  if (contentDivElem) {
    const root = createRoot(contentDivElem);

    const App: React.FC = () => {
      return <TopContent />;
    };
    root.render(<App />);
  }
});
